<template>
  <div class="classroom-allocation-editor">
    <div
      v-for="(row, idx) in value"
      :key="'cr-' + idx"
      class="row align-items-start classroom-allocation-row"
    >
      <div :class="showPercent ? 'col-md-7' : 'col-md-12'">
        <a-form-item
          :label="idx === 0 ? $t('decaissement.classRoom') : ''"
          :required="idx === 0 && required"
        >
          <a-select
            :value="row.classRoom"
            show-search
            option-filter-prop="children"
            :placeholder="$t('decaissement.classRoomPlaceholder')"
            allow-clear
            @change="(v) => onClassRoomChange(idx, v)"
          >
            <a-select-option
              v-for="c in availableClassRooms(idx)"
              :key="c._id"
              :value="c._id"
            >
              {{ c.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div v-if="showPercent" class="col-md-4">
        <a-form-item
          :label="idx === 0 ? $t('decaissement.activityPercent') : ''"
        >
          <a-input-number
            :value="row.percent"
            :min="0"
            :max="100"
            :precision="2"
            :disabled="!row.classRoom"
            style="width: 100%"
            @change="(v) => onPercentChange(idx, v)"
          />
        </a-form-item>
      </div>
      <div v-if="value.length > 1" class="col-md-1 pt-1">
        <a-button
          type="danger"
          icon="delete"
          size="small"
          :aria-label="$t('action.supprimer')"
          @click="removeRow(idx)"
        />
      </div>
    </div>
    <a-button type="dashed" block class="mb-2" icon="plus" @click="addRow">
      {{ $t("decaissement.addClassRoomAllocation") }}
    </a-button>
  </div>
</template>

<script>
export default {
  name: "ClassroomAllocationEditor",
  props: {
    value: {
      type: Array,
      required: true,
    },
    classRooms: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    /** Show percent inputs when combined allocations need a split (>1 selected items). */
    showPercent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    availableClassRooms(idx) {
      const taken = new Set(
        this.value
          .map((r, i) => (i !== idx && r.classRoom ? r.classRoom : null))
          .filter(Boolean)
      );
      return (this.classRooms || []).filter(
        (c) => !taken.has(c._id) || this.value[idx].classRoom === c._id
      );
    },
    onClassRoomChange(idx, classRoomId) {
      const next = this.value.map((r, i) => {
        if (i !== idx) return { ...r };
        return { ...r, classRoom: classRoomId };
      });
      this.$emit("input", next);
      this.$emit("structure-change");
    },
    onPercentChange(idx, v) {
      const num = v == null || v === "" ? 0 : Number(v);
      const next = this.value.map((r, i) =>
        i === idx ? { ...r, percent: num } : { ...r }
      );
      this.$emit("input", next);
    },
    addRow() {
      const next = this.value.map((r) => ({ ...r }));
      next.push({ classRoom: undefined, percent: 0 });
      this.$emit("input", next);
      this.$emit("structure-change");
    },
    removeRow(idx) {
      if (this.value.length <= 1) return;
      const next = this.value
        .filter((_, i) => i !== idx)
        .map((r) => ({ ...r }));
      this.$emit("input", next);
      this.$emit("structure-change");
    },
  },
};
</script>

<style scoped>
.classroom-allocation-row {
  margin-bottom: 0;
}
</style>
